function getHeight() {
  let headerHeight = $('.header').outerHeight();
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  let footerHeight = $('.footer').outerHeight();
  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
}
getHeight();